export default __webpack_public_path__ + "static/media/Attractiveness.efb7d7dc.jpg";